export default "__VITE_ASSET__BBtaGwq7__"